/**
 * Trigger: tr_categories_hard_delete
 * Purpose: Cascade delete related entities when a category is hard deleted
 * Table: categories
 * Event: BEFORE DELETE
 */
export const TR_CATEGORIES_HARD_DELETE = `
CREATE TRIGGER tr_categories_hard_delete
BEFORE DELETE ON categories
FOR EACH ROW
BEGIN
  DELETE FROM categories WHERE parent_category_id = old._id;
  DELETE FROM expenses WHERE category_id = old._id;
  DELETE FROM incomes WHERE category_id = old._id;
  DELETE FROM planned_expenses WHERE category_id = old._id;
  DELETE FROM planned_incomes WHERE category_id = old._id;
  DELETE FROM creditors WHERE category_id = old._id;
  DELETE FROM debtors WHERE category_id = old._id;
END;
`;
